import { useEffect, useState } from "react";
import { Capacitor } from "@capacitor/core";
import { useAuthStore } from "@/stores/authStore";
import { tryRefreshingToken } from "./tryRefreshingToken";

// On native, CapacitorHttp's fetch patch and the iOS cookie jar can race
// right after WKWebView reloads (manual reload or iOS auto-restoring an
// evicted WebView when returning from background), so retry a few times
// before giving up and showing sign-in.
const refreshWithNativeRetries = async (
  setToken: (t: string) => void,
  clearToken: () => void,
) => {
  for (let i = 0; i < 4; i++) {
    const token = await tryRefreshingToken(setToken, clearToken).catch(
      () => null,
    );
    if (token) return;
    await new Promise((r) => setTimeout(r, 300));
  }
};

export const useAuthBootstrap = () => {
  const [loading, setLoading] = useState(true);
  const { setToken, clearToken } = useAuthStore();

  useEffect(() => {
    const isNative = Capacitor.isNativePlatform();
    const bootstrap = isNative
      ? refreshWithNativeRetries(setToken, clearToken)
      : tryRefreshingToken(setToken, clearToken);

    void bootstrap.finally(() => setLoading(false));
  }, [setToken, clearToken]);

  return { loading };
};
